import { DATA_DELETION } from "@netkeep/legal";
import { LegalDocumentView } from "@/components/LegalDocumentView";

export default function DeleteDataPage() {
  return <LegalDocumentView doc={DATA_DELETION} />;
}
